// SD-1823: All 29 canonical US IANA timezones (zone1970.tab) + US territories.
// Chosen over IP geolocation: sync, zero latency, no API key, works offline.
// Fallback to true (US) on error — safe default preserving existing SMS behavior.
const US_TIMEZONES = new Set([
  // Eastern
  'America/New_York', 'America/Detroit', 'America/Kentucky/Louisville',
  'America/Kentucky/Monticello', 'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes', 'America/Indiana/Winamac',
  'America/Indiana/Marengo', 'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  // Central
  'America/Chicago', 'America/Indiana/Tell_City', 'America/Indiana/Knox',
  'America/Menominee', 'America/North_Dakota/Beulah',
  'America/North_Dakota/Center', 'America/North_Dakota/New_Salem',
  // Mountain
  'America/Denver', 'America/Boise', 'America/Phoenix',
  // Pacific
  'America/Los_Angeles',
  // Alaska
  'America/Anchorage', 'America/Juneau', 'America/Sitka',
  'America/Yakutat', 'America/Nome', 'America/Metlakatla', 'America/Adak',
  // Hawaii
  'Pacific/Honolulu',
  // US Territories
  'America/Puerto_Rico', 'America/Virgin',
  'Pacific/Guam', 'Pacific/Pago_Pago',
]);

export const isUSTimezone = (): boolean => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return US_TIMEZONES.has(timezone);
  } catch {
    return true;
  }
};
